import React, { useEffect } from "react";
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate } from "react-router-dom";
import { useGtm, buildAdPayload, getKstTimestamp, fetchAdPayload } from 'hooks/useGtm';
import SsoCallBackApi from "Apis/SsoCallBackApi";
const SsoLoginCallBack = (sso_type: string) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { push: gtmPush } = useGtm();
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }  
    let query =serchParamsFunc();
    let code = query.get("code");
    let state = query.get("state");
    let AppUrl = "";

    useEffect(() => {
        SsoCallBackApi(sso_type, code, state)
            .then(async (Resp) => {
                if (Resp.apiBody?.appYn === "Y") {
                    AppUrl ="/Connect";
                }
                if (!isMobile && window.opener && window.opener.SsoRespFunc) {
                    window.opener.SsoRespFunc(Resp.apiHdr.code);
                    window.close();
                }else if(isMobile) {
                    switch (Resp.apiHdr.code) {
                        case "ATHN0000":
                            if (window.fbq) {
                                window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                            }
                            const tsKst = getKstTimestamp();
                            const adPayload = await fetchAdPayload( 'BBO');
                            try {
                                gtmPush('BBO_GA_Login_Complete', {
                                    ts: tsKst,
                                    ...adPayload,
                                });
                            } catch (gtmErr) {
                                if (typeof window !== 'undefined') {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        event: 'BBO_GA_Login_Complete',
                                        ts: tsKst,
                                        ...adPayload,
                                    });
                                }
                            }
                            if (Resp.apiBody.appYn === "Y") {
                                return navigate("/Connect/AppStrt", { state: { pageCd: "login" }, replace: true });    
                                
                            }
                             // 리퍼러 파라미터가 있으면 해당 페이지로 이동
                            if(Resp.apiBody?.redirectUri.length > 0) {
                                return navigate(decodeURIComponent(Resp.apiBody.redirectUri), { replace: true });
                            }
                            navigate("/", { replace: true });
                            break;
                        case "ATHN2002":
                            navigate(AppUrl + "/BlckMemb", { replace: true });
                            break;
                        case "ATHN2005":
                            navigate(AppUrl + "/membLvdCncl", { replace: true });
                            break;
                        case "ATHN2007":
                            navigate(AppUrl + "/OtpAthn");
                            break;
                        case "ATHN2003":
                            navigate(AppUrl + "/DrmcMemb", { replace: true });
                            break;
                        case "ATHN2009":
                            navigate(AppUrl + `/MembJoin`, { state: { joinTypeCd: "SSO" } });
                            break;
                        case "ATHN2309":
                        case "BEPR4999":
                            navigate(AppUrl + "/Login", { replace: true });
                        break;
                    }
                }
            })
            .catch(() => {
            });
    }, []);


    return(
        <>
        </>
    )
}

export default SsoLoginCallBack;